const STRONG = {
  id: 0,
  text: 'Strong',
};
const MEDIUM = {
  id: 1,
  text: 'Medium',
};
const WEAK = {
  id: 2,
  text: 'Weak',
};

const STRENGTH_REGEXPS = {
  /* 1. at least one lowercase letter
   * 2. one uppercase letter
   * 3. one digit
   * 4. one special character
   * 5. at least eight characters long
  */
  [STRONG.id]: /(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9])(?=.{8,})/,

  /*
   * At least four characters long and meets all the "Strong" requirements,
  */
  [MEDIUM.id]: /(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9])(?=.{4,8})/,
};

function setLevelWeak(element) {
  element.classList.add('faPasswordStrength--weak');
  element.classList.remove('faPasswordStrength--medium');
  element.classList.remove('faPasswordStrength--strong');
}

function setLevelMedium(element) {
  element.classList.add('faPasswordStrength--medium');
  element.classList.remove('faPasswordStrength--weak');
  element.classList.remove('faPasswordStrength--strong');
}

function setLevelStrong(element) {
  element.classList.add('faPasswordStrength--strong');
  element.classList.remove('faPasswordStrength--weak');
  element.classList.remove('faPasswordStrength--medium');
}

function checkPasswordStrength(target) {
  const password = target.srcElement.value;
  const resultTargetId = target.srcElement.dataset.passwordStrengthTextFor;
  const resultLevelId = target.srcElement.dataset.passwordStrengthLevelFor;

  if (!resultTargetId) {
    throw new Error("Password strength result target text id not provided");
  }

  if (!resultLevelId) {
    throw new Error("Password strength result target level id not provided");
  }

  const resultTargetElement = document.getElementById(resultTargetId);
  if (!resultTargetElement) {
    throw new Error(`Could not find element with id ${resultTargetId}`);
  }

  const levelTargetElement = document.getElementById(resultLevelId);
  if (!levelTargetElement) {
    throw new Error(`Could not find element with id ${resultLevelId}`);
  }

  if (password === "") {
    resultTargetElement.innerText = WEAK.text;
    setLevelWeak(levelTargetElement);
  }

  if (STRENGTH_REGEXPS[STRONG.id].test(password)) {
    resultTargetElement.innerText = STRONG.text;
    setLevelStrong(levelTargetElement);
  } else if (STRENGTH_REGEXPS[MEDIUM.id].test(password)) {
    resultTargetElement.innerText = MEDIUM.text;
    setLevelMedium(levelTargetElement);
  } else {
    resultTargetElement.innerText = WEAK.text;
    setLevelWeak(levelTargetElement);
  }
}

function attachPasswordStrengthChecker() {
  const els = document.getElementsByClassName("password-strength-target");
  if (els) {
    for (let i = 0; i < els.length; i++) {
      const el = els[i];
      el.addEventListener("input", checkPasswordStrength, false);
    }
  }
}

document.addEventListener("DOMContentLoaded", attachPasswordStrengthChecker, false);
